/*
 * @Description: 证件字段转换器
 * @Author: lijinpeng
 * @Date: 2024-06-14 15:47:57
 * @LastEditTime: 2024-06-14 15:47:57
 * @LastEditors: lijinpeng
 */
const ocrTypeMap = {
  identityPositiveImage: {
    // 司机身份证正面
    ocrType: 'IDENTITY_CARD_FRONT',
    dataMap: {
      name: 'name', // 姓名
      identityNumber: 'identityNumber', // 身份证号
      address: 'identityAddress', // 身份证上记录的住址
    },
  },
  identityReverseImage: {
    // 司机身份证反面
    ocrType: 'IDENTITY_CARD_BACK',
    dataMap: {
      startDate: 'identityValidityStart', // 身份证有效期起始时间
      endDate: 'identityValidityEnd', // 身份证有效期终止时间
      issuingAuthority: 'identityLicenseAgency', // 身份证签发机关
    },
  },
  driverLicenseOriginalImage: {
    // 司机驾驶证正面
    ocrType: 'DRIVING_LICENSE_FRONT',
    dataMap: {
      drivingLicenseNumber: 'driverNo', // 驾驶证号
      drivingType: 'driverLicenseType', // 驾驶证类型
      issuingAuthority: 'driverLicenseAgency', // 驾驶证发证机关
      startDate: 'driverLicenseValidityStart', // 驾驶证有效期起始时间
      endDate: 'driverLicenseValidityEnd', // 驾驶证有效期终止时间
    },
  },
  driverLicenseDeputyImage: {
    // 司机驾驶证反面
    ocrType: 'DRIVING_LICENSE_BACK',
    dataMap: null,
  },
  professionalImage: {
    // 司机从业资格证
    ocrType: 'QUALIFICATION_CERTIFICATE',
    dataMap: {
      certificateNumber: 'professionalNumber', // 从业资格证号
      issueDate: 'professionalValidityStart', // 从业资格证开始时间
      expiryDate: 'professionalValidityEnd', // 从业资格证结束时间
      category: 'professionalType', // 从业资格证类型
    },
  },
  vehicleLicenseOriginalImage: {
    // 车辆行驶证正面
    ocrType: 'VEHICLE_LICENSE_FRONT_GUA',
    dataMap: {
      vehicleNumber: 'vehicleNo', // 车牌号
      vehicleType: 'vehicleType', // 车辆类型
      vin: 'chassisNo', // 车辆识别号码
      engineNumber: 'engineNo', // 发动机号
      brandModel: 'vehicleBrand', // 车辆品牌型号
      owner: 'owner', // 所有人
      issuingAuthority: 'vehicleLicenseAuthority', // 签发机关
      registrationDate: 'vehicleLicenseRegisterDate', // 注册日期
      issueDate: 'vehicleLicenseIssueDate', // 发证日期
      usingNature: 'natureUsage', // 使用性质
    },
  },
  vehicleLicenseDeputyImage: {
    // 车辆行驶证反面
    ocrType: 'VEHICLE_LICENSE_BACK',
    dataMap: {
      fileNumber: 'drivingLicenseFileNumber', // 行驶证档案编号
      fuelType: 'fuelType', // 车辆能源类型
      grossMass: 'grossMass', // 总质量(KG)
      curbWeight: 'curbWeight', // 整备质量(KG)
      approvedLoad: 'approverLoad', // 核定载质量
      tractionGrossMass: 'totalTractionMass', // 牵引总量
      length: 'vehicleLength', // 外廓尺寸(长)
      width: 'vehicleWidth', // 外廓尺寸(宽)
      height: 'vehicleHigh', // 外廓尺寸(高)
      lastInspectionDate: 'drivingLicenseEndDate', // 行驶证有效期至
    },
  },
  drivingPermitPhotosExtra: {
    // 车辆行驶证年检页
    ocrType: 'VEHICLE_LICENSE_BACK',
    dataMap: {
      lastInspectionDate: 'drivingLicenseEndDate', // 行驶证有效期至
    },
  },
  transportImage: {
    // 车辆道路运输证
    ocrType: 'TRANSPORT_CERTIFICATE',
    dataMap: {
      licenseNumber: 'transportNo', // 道路运输证号
      ownerName: 'merchantName', // 道路运输证业户名称
      businessCertificate: 'transportOperationNo', // 道路运输经营许可证号
      vehicleNumber: 'transportVehicleNo', // 道路运输证车牌号
      issueDate: 'transportStartDate', //发证日期
      expiryDate: 'transportEndDate', //有效期至
    },
  },
  licensePhotoExtra: {
    // 车辆营运证
    ocrType: 'TRANSPORT_CERTIFICATE',
    dataMap: {
      expiryDate: 'periodEndDate', // 营运证有效期
    },
  },
  vehicleFrontImage: {
    // 车头照
    ocrType: 'AUTO',
    dataMap: null,
  },
  trailerLicenseOriginalImage: {
    // 挂车行驶证正面
    ocrType: 'VEHICLE_LICENSE_FRONT_GUA',
    dataMap: {
      vehicleNumber: 'trailerLicenseNo', // 车牌号
    },
  },
  identityFrontFace: {
    // 经纪人身份证正面
    ocrType: 'IDENTITY_CARD_FRONT',
    dataMap: {
      name: 'payeeName', // 姓名
      identityNumber: 'payeeIdentityNo', // 身份证号
      address: 'identityAddress', // 身份证上记录的住址
    },
  },
  identityBackFace: {
    // 经纪人身份证反面
    ocrType: 'IDENTITY_CARD_BACK',
    dataMap: {
      startDate: 'identityValidityStart', // 身份证有效期起始时间
      endDate: 'identityValidityEnd', // 身份证有效期终止时间
    },
  },
};

export default ocrTypeMap;
